import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "id-iden" }
const _hoisted_3 = { class: "stack-tabs" }
const _hoisted_4 = ["onMousedown", "onClick"]
const _hoisted_5 = { class: "tab-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.children)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: _ctx.uid.toString(),
        id: _ctx.id.toString(),
        style: _normalizeStyle('min-width:250px; min-height:150px; flex:' + _ctx.componentState.flex),
        class: "stack-container"
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.id), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (child, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass([{ active: _ctx.activeTab == i }, "stack-tab"]),
              onMousedown: ($event: any) => (_ctx.dragStart($event, child.id)),
              key: i,
              onClick: ($event: any) => (_ctx.activeTab = i)
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(`${child.componentName}`)), 1)
            ], 42, _hoisted_4))
          }), 128))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (child, i) => {
          return _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(child.component ? 'LayoutComponent' : 'LayoutContainer'), {
            stacked: "",
            key: i,
            type: child.type,
            id: child.id,
            componentState: child.componentState,
            componentName: child.componentName,
            children: child.children || [],
            component: child.component
          }, null, 8, ["type", "id", "componentState", "componentName", "children", "component"])), [
            [_vShow, _ctx.activeTab == i]
          ])
        }), 128))
      ], 12, _hoisted_1))
    : _createCommentVNode("", true)
}